import { RAW_COLORS } from '@pixee/design-system/primitives'
import chroma from 'chroma-js'
import { Tool } from './api-client/api-schemas'

export const toolColors: Record<Tool, { backgroundColor: string }> = {
  aikido_sast: {
    backgroundColor: '#6357F5',
  },
  aikido_sca: {
    backgroundColor: '#6357F5',
  },
  appscan: {
    backgroundColor: '#24AEB6',
  },
  checkmarx: {
    backgroundColor: '#7F4FFC',
  },
  checkmarx_enterprise: {
    backgroundColor: '#2B347B',
  },
  codeql: {
    backgroundColor: '#2088FF',
  },
  contrast: {
    backgroundColor: '#0E9E53',
  },
  defectdojo: {
    backgroundColor: '#44DEFF',
  },
  datadog_sast: {
    backgroundColor: '#632CA6',
  },
  arnica_sast: {
    backgroundColor: '#3BBFA0',
  },
  fortify: {
    backgroundColor: '#1A6AFF',
  },
  gitleaks: {
    backgroundColor: '#3D3D3D',
  },
  gitlab_sast: {
    backgroundColor: '#fc6d26',
  },
  gitlab_dependency_scanning: {
    backgroundColor: '#fc6d26',
  },
  dependabot: {
    backgroundColor: '#0366d6',
  },
  semgrep: {
    backgroundColor: '#13BF95',
  },
  snyk: {
    backgroundColor: '#A44BBF',
  },
  sonar: {
    backgroundColor: '#FD3456',
  },
  polaris_sast: {
    backgroundColor: '#9A73B3',
  },
  polaris_sca: {
    backgroundColor: '#9A73B3',
  },
  black_duck_hub_sca: {
    backgroundColor: '#9A73B3',
  },
  // Every other entry is a third-party brand colour with no token to point at; the Pixee AI
  // Scanner is ours, so it reads from the brand token rather than pinning a copy of its value.
  pixee_ai: {
    backgroundColor: RAW_COLORS.primary.nebula,
  },
  freeform: {
    backgroundColor: '#5B616E',
  },
  veracode: {
    backgroundColor: '#00B9FF',
  },
  zap: {
    backgroundColor: '#00A29A',
  },
}

export const withAlpha = (original: string, opacity: number): string => {
  return chroma(original).alpha(opacity).css()
}

/**
 * Resolves a CSS variable reference to its computed value.
 * Useful for APIs that need actual color values (e.g., canvas-based libraries like react-confetti).
 * @param cssVariable - A CSS variable reference like "var(--colors-primary-nebula)"
 * @returns The computed color value (e.g., "#00E79A")
 */
export const getCssVariable = (cssVariable: `var(--${string})`): string => {
  const variableName = cssVariable.slice(4, -1) // Extract "--foo" from "var(--foo)"
  // eslint-disable-next-line no-restricted-properties -- utility needs direct DOM access for computed styles
  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim()
}
